import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "@/lib/api";

const FilterCtx = createContext(null);

function initialFromUrl() {
  const q = new URLSearchParams(window.location.search);
  const num = (k) => (q.get(k) ? Number(q.get(k)) : null);
  return { uid: q.get("uid"), tipe: q.get("tipe"), unit: q.get("unit"), tahun: num("tahun"),
           mode: q.get("mode") || "tahun", value: num("value") };
}

export function FilterProvider({ children }) {
  const [filters, setState] = useState(initialFromUrl);
  const [meta, setMeta] = useState(null);
  const [dataVersion, setDataVersion] = useState(0);
  const [metaError, setMetaError] = useState(null);

  useEffect(() => {
    let alive = true;
    let timer;
    const load = () => api.get("/meta/filters", { timeout: 20000 }).then((r) => {
      if (!alive) return;
      setMetaError(null);
      setMeta(r.data);
      setState((f) => {
        const years = r.data.years || [];
        const tahun = f.tahun && years.includes(f.tahun) ? f.tahun : r.data.latest?.tahun || years[0] || null;
        return { ...f, tahun };
      });
    }).catch(() => {
      if (!alive) return;
      setMetaError("Gagal memuat data filter. Mencoba lagi…");
      timer = setTimeout(load, 5000);
    });
    load();
    return () => { alive = false; clearTimeout(timer); };
  }, [dataVersion]);

  const setFilters = useCallback((patch) => {
    setState((f) => {
      const next = { ...f, ...patch };
      if (patch.mode && patch.mode !== f.mode) next.value = patch.mode === "tahun" ? null : 1;
      if ((patch.uid !== undefined && patch.uid !== f.uid) || (patch.tipe !== undefined && patch.tipe !== f.tipe)) {
        if (!("unit" in patch)) next.unit = null;
      }
      return next;
    });
  }, []);

  const resetFilters = useCallback(() => setState((f) => ({ uid: null, tipe: null, unit: null, tahun: f.tahun, mode: "tahun", value: null })), []);

  const params = useMemo(() => {
    const p = {};
    Object.entries(filters).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== "") p[k] = v; });
    return p;
  }, [filters]);

  const value = {
    filters, setFilters, resetFilters, meta, metaError, params, ready: !!meta,
    dataVersion, refreshData: () => setDataVersion((v) => v + 1),
  };
  return <FilterCtx.Provider value={value}>{children}</FilterCtx.Provider>;
}

export const useFilters = () => useContext(FilterCtx);
